import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(({ palette, spacing }: Theme) => ({
  container: {
    display: 'flex',
    flex: '1',
    height: '100%',
  },

  info: {
    color: palette.grey[400],
    whiteSpace: 'nowrap',
    marginTop: spacing(2),
    '& > div': {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
  },

  containerRight: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    '& > div': {
      color: palette.neutral[100],
      marginBottom: spacing(2),
    },
  },
}));

export default useStyles;
